import LoyaltyAvatarDesktop from "components/organisms/LoyaltyAvatarDesktop";
import LoyaltyAvatarMobile from "components/organisms/LoyaltyAvatarMobile";
import { useBreakpoint } from "hooks/useBreakpoint";
import { useSelector } from "react-redux";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { useGetMascotsLoyalty } from "queries/useGetLoyaltyMascots";
import * as userSelectors from "redux/user/selectors";
import { useGetUserMascots } from "queries/useGetUserMascots";
import { useActivateMascot } from "queries/useActivateMascot";
import { formatMascotsToListAvatars } from "utils/loyaltyMascots";
import { LoyaltyTitle } from "../../components/atoms/LoyaltyTitle";

const LoyaltyAvatarPageContainer = () => {
  const { isDesktop } = useBreakpoint();
  const currencyCode = useSelector(userSelectors.currency);
  const { data } = useGetLoyaltyUser();
  const { data: mascotsLoyalty } = useGetMascotsLoyalty({
    loyaltyId: data?.data?.data?.id || "",
    currency: String(currencyCode?.isoCode) || "",
  });

  const { data: mascotsUser } = useGetUserMascots();
  const { activateMascot } = useActivateMascot();

  const mascots = formatMascotsToListAvatars(
    mascotsUser?.data?.data,
    mascotsLoyalty?.data?.data,
  );

  const activeMascot =
    mascotsUser?.data?.data?.find((mascot) => mascot.status === "active") ||
    undefined;

  return (
    <>
      <LoyaltyTitle title="loyalty.avatar.title" upperCase />
      {isDesktop ? (
        <LoyaltyAvatarDesktop
          activeId={activeMascot?.link || null}
          mascots={mascots}
          // eslint-disable-next-line react/jsx-handler-names
          onHandleSelect={activateMascot}
        />
      ) : (
        <LoyaltyAvatarMobile
          activeAvatarId={activeMascot?.link || null}
          activeAvatar={activeMascot?.link || null}
          mascots={mascots}
          // eslint-disable-next-line react/jsx-handler-names
          onHandleSelect={activateMascot}
        />
      )}
    </>
  );
};

export default LoyaltyAvatarPageContainer;
